import ShipLaborAttendanceDaily from '@/models/ShipLaborAttendanceDaily'
import ShipLaborWork from '@/models/ShipLaborWork'

export default class LaborAttendAll {
    static of(shipId, searchAt) {
        return Promise.resolve()
            .then(() => {
                return ShipLaborWork.api().fetch(shipId)
            })
            .then(() => {
                return ShipLaborAttendanceDaily.api().fetch(shipId, searchAt)
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
